"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobx_1 = require("mobx");

function mergeObservables(target, source) {
  var t = target;
  var s = source;

  if (_typeof(t) === 'object' && _typeof(s) === 'object') {
    for (var key in t) {
      if (t[key] && _typeof(t[key]) === 'object' && _typeof(s[key]) === 'object') {
        if (mobx_1.isObservableMap(t[key])) t[key].merge(s[key]);else if (mobx_1.isObservableArray(t[key])) t[key].replace(s[key]);else if (mobx_1.isObservableObject(t[key])) t[key] = mergeObservables(t[key], s[key]);
      } else if (s[key] !== undefined) {
        t[key] = s[key];
      }
    }
  }

  return t;
}

exports.mergeObservables = mergeObservables;